import {
  Comparison,
  GetParentObject,
  QuestionNamesById,
  QuestionThreadParent,
  TriggerValue,
} from '@src/app-components/dynamic-form/types';

export const permitProcessGuideQuestionNameById: QuestionNamesById = {
  1: 'requestJd',
  2: 'isArDelineationConducted',
  3: 'isPermitRequired',
  4: 'hasJpa',
  5: 'isJpaIntegratedInRrs',
  6: 'isGpQualified',
  7: 'isPcnRequired',
  8: 'isNwpRequirePcn',
  9: 'otherNwp',
  10: 'submitIndPermit',
  11: 'activityNotRegulated',
  12: 'notImpactWaters',
  13: 'requestModification',
  14: 'requestReverification',
};

export const permitProcessGuideQuestionIdByName = Object.fromEntries(
  Object.entries(permitProcessGuideQuestionNameById).map(([key, value]) => [value, parseInt(key)])
);

export const getParentObject: GetParentObject = (
  parentId: number,
  parentTypeId: number,
  comparison: Comparison,
  triggerValue: TriggerValue
): QuestionThreadParent => {
  const parentName = permitProcessGuideQuestionNameById[
    parentId as keyof typeof permitProcessGuideQuestionNameById
  ] as string;

  return {
    parentId,
    parentName,
    comparison,
    triggerValue,
    parentTypeId,
  };
};
